import { useEffect } from 'react';

const AppleAppSiteAssociation = () => {
  const appleAppSiteAssociation = {
    "applinks": {
      "apps": [],
      "details": [
        {
          "appID": "63G3T8C3T9.com.dotstudiopro.greenlight",
          "paths": [
            "/channels/*",
            "/channels",
            "/on-demand",
            "/on-demand/*",
            "/watch/*",
            "/live-tv/*",
            "/watch",
            "/live-tv"
          ]
        }
      ]
    }
  };

  useEffect(() => {
    // Set the content type to application/json
    document.querySelector('meta[name="content-type"]')?.setAttribute('content', 'application/json');
  }, []);

  // Return the JSON as a pre-formatted string
  return (
    <pre style={{ 
      fontFamily: 'monospace', 
      whiteSpace: 'pre-wrap', 
      margin: 0,
      padding: 0,
      backgroundColor: 'transparent',
      border: 'none'
    }}>
      {JSON.stringify(appleAppSiteAssociation, null, 2)}
    </pre>
  );
};

export default AppleAppSiteAssociation;

